import { useContext } from "react";
import { Link } from "react-router-dom";
import { landingOptions } from "../../constants";
import * as styles from "./styles";
import { CMSContext } from "../..";
import { getTimeOfDay } from "../../helpers";
import Routes from "./routes";

export default function Base() {
  const { state } = useContext(CMSContext);
  const timeOfDay = getTimeOfDay();
  const user =
    typeof state.username !== "object" ? state.username : "CTress Admin";

  return (
    <div className={styles.parentContainer}>
      <div className={styles.optionsContainer}>
        <Link to={'/admin'} className={styles.welcomeTitle}>
          {timeOfDay},<div className="italic pt-2">{user}</div>
        </Link>
        <div className="border-b-2 my-8 border-dotted"></div>
        {landingOptions.map((item) => (
          <>
            <div
              className="font-bold tracking-wider uppercase"
              key={item.display}
            >
              {item.display}
            </div>
            <div className="flex flex-col text-xs my-2">
              {item.options.map((nestedItem) => (
                <Link
                  key={nestedItem.display}
                  to={nestedItem.link}
                  className="ml-4 tracking-wider my-2 uppercase"
                >
                  {nestedItem.display}
                </Link>
              ))}
            </div>
          </>
        ))}
      </div>
      <div className="w-full h-full justify-end flex">
        <div className="w-4/5 h-screen overflow-scroll">
          <Routes />
        </div>
      </div>
    </div>
  );
}
